import { Navigate } from 'react-router'
import { PageContainer, StatePanel } from './common'
import { useAuth } from '../hooks/useAuth'
import { useOrganization } from '../hooks/useOrganization'
import { productName } from '../config/studioProducts'
import { ROLES } from '../constants/roles'

function ProductRouteGuard({
  productKey,
  action = 'view',
  children,
  fallbackPath,
  title,
  description,
}) {
  const { loading, productsLoading, hasProductAccess } = useOrganization()
  const { hasRole } = useAuth()

  if (loading || productsLoading) {
    return (
      <PageContainer>
        <StatePanel state="loading" title="Loading workspace" />
      </PageContainer>
    )
  }

  if (!hasProductAccess(productKey, action)) {
    if (fallbackPath) {
      return <Navigate to={fallbackPath} replace />
    }

    const name = productName(productKey)
    // Organization users can't tell a product their organization lacks from
    // one Studio hides from their role (internal-only products stay enabled
    // for public runtimes), so by default they get "no access" rather than
    // "not enabled".
    const organizationUser = !hasRole(ROLES.INTERNAL_ORG_ADMIN)
    const defaultTitle = organizationUser ? `You don't have access to ${name}` : `${name} is not enabled`
    const defaultDescription = organizationUser
      ? 'Ask your organization admin if you need it.'
      : 'This organization does not have access to this product workspace.'
    return (
      <PageContainer>
        <StatePanel
          state="restricted"
          title={title || defaultTitle}
          description={description || defaultDescription}
        />
      </PageContainer>
    )
  }

  return children
}

export default ProductRouteGuard
